import {Injectable} from '@angular/core';
import {SearchRequestDto, SearchResponseDto} from '../@api';

@Injectable({
    providedIn: 'root'
})
export class SearchService {

    public blocked: boolean;

    public searchRequest: SearchRequestDto = {
        text: null
    };

    public response: SearchResponseDto = {
        total: 0,
        time: 0,
        results: []
    };
}
